export default class DocumentError {
  nurse_id: string[] = []
  doc_type: string[] = []
  key: string[] = []
  page_num: string[] = []
}